import { ForwardedRef, forwardRef } from 'react';
import { InputButtonProps } from './AutocompleteInputButton.types';
import { ButtonWrapper, Container, InputGroup, LabelWrapper, StyledLabel } from './AutocompleteInputButton.styles';
import Button from '../Button/Button';
import Select, {components, MenuListProps} from 'react-select';
import { useTheme } from '@emotion/react';



const AutocompleteInputButton = forwardRef<any, InputButtonProps>(({ buttonProps, disabled, id, options, onInputChange, onChange, label, isLoading = false }, ref: ForwardedRef<any>) =>{
    const theme = useTheme();
    const customStyles = {
        dropdownIndicator: (provided: any) => ({
          ...provided,
          display: 'none',
        }),
        control: (baseStyles: any, state: { isDisabled: any; }) => ({
          ...baseStyles,
          position: 'relative',
          width: '300px',
          height: '40px',
          backgroundColor: theme.colors.white,
          border: `1px solid ${theme.colors.gray600}`,
          fontFamily: 'Open Sans',
          lineHeight: '22px',
          fontWeight: '400',
        })
      }
  
      const MenuList = (props: MenuListProps) => {
        return (
          <components.MenuList {...props}>
            {
              Array.isArray(props.children)
              ? props.children.slice(0, 5)
              : props.children
            }
          </components.MenuList>
        )
      }
return (
<>
<InputGroup>
<Container>
    <LabelWrapper>
      <StyledLabel htmlFor={id} aria-label={label}>{label}</StyledLabel>
    </LabelWrapper>      <Select
        ref={ref}
        styles={customStyles}
        options={options}
        getOptionValue={(option: any) => option.value}
        getOptionLabel={(option: any) => `${option.label}`}
        isDisabled={disabled}
        id={id}
        components={{MenuList}}
        placeholder= {isLoading ? 'Loading...' : ''}
        name='number'
        onChange={onChange}
        // onInputChange={onInputChange}
      />
      </Container>
    <ButtonWrapper>
      <Button {...buttonProps} />
    </ButtonWrapper>    </InputGroup>
</>
);

});

export default AutocompleteInputButton;
